import StitchFeaturePage from "../../components/sections/StitchFeaturePage";

const features = [
  { title: "Document Ingestion", desc: "Structured intake from PDFs, docs, knowledge bases, and mixed operational sources." },
  { title: "Chunking & Embedding", desc: "Retrieval-oriented preprocessing designed for relevance instead of naive document slicing." },
  { title: "Vector Database Setup", desc: "Pinecone, pgvector, Qdrant, or similar stores selected for the actual product need." },
  { title: "Retrieval Tuning", desc: "Prompting, ranking, and context assembly improved for higher-quality grounded answers." },
  { title: "Evaluation & Guardrails", desc: "Testing, observability, and retrieval checks that reduce hallucination risk." },
  { title: "Product Integration", desc: "RAG connected into chat interfaces, internal tools, CRMs, ERPs, and support experiences." },
];

const RagPipelines = () => (
  <StitchFeaturePage
    label="RAG PIPELINES & VECTOR DBS"
    title="Grounded AI"
    titleAccent="that retrieves well."
    subtitle="Retrieval-augmented pipelines for teams that want their AI answers anchored to business context and real source material."
    features={features}
    ctaLabel="BUILD A RAG PIPELINE"
  />
);

export default RagPipelines;
